import * as React from "react"
import * as styles from "./index.module.scss"
import Container from "@/components/container"

const CustomerSaying: React.FC<{
  saying: CustomerQuote
}> = ({ saying }) => (
  <section className={styles.customerSaying}>
    <Container>
      <div className={styles.block}>
        <div className={styles.quote}>
          <i className="iconfont icon-quotes" />
        </div>
        <div className={styles.content}>
          <h3>{saying.quote}</h3>
          <h5>{`${saying.personName} | ${saying.professionalTitle}`}</h5>
        </div>
      </div>
    </Container>
  </section>
)
export default CustomerSaying
